module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/002-b3f96a026da05f72bac73aae0b3c7234.jpg";